import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

import ErrorBoundary from './ErrorBoundary';

interface RouteErrorBoundaryProps {
  children: ReactNode;
}

/**
 * Error boundary keyed on the current pathname, so a crash in one route is
 * automatically cleared when the user navigates elsewhere (instead of leaving
 * them stuck on the fallback). Must be rendered inside a Router.
 */
const RouteErrorBoundary = ({ children }: RouteErrorBoundaryProps) => {
  const location = useLocation();

  return <ErrorBoundary resetKeys={[location.pathname]}>{children}</ErrorBoundary>;
};

export default RouteErrorBoundary;
